import { Loader, LoaderWrapper, classNames } from '@fl/cmsch-fe-library';
import { isEmpty } from 'lodash/fp';
import React, { Fragment, FC, memo, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { AssociationType } from 'api/gen/AssociationType';
import { useOurTranslation } from 'app/translations';
import { Ant } from 'common/ant';
import { useAnimalTab } from '../../hooks/use-animal-tab';
import { matingSelector } from '../../model';
import { MatingBullsFilterForm } from '../bulls-filter-form';
import { MatingBullsTable } from '../bulls-table';
import { MatingBullsModals } from './bulls-modals';
import { useBullTabState } from './bulls-tab-state';
const MALE = 'MALE';
interface Props {
  loadingMsg: string;
  isMating?: boolean;
  associationType: AssociationType;
}
const BullSelectionTabBase: FC<Props> = ({
  associationType,
  loadingMsg,
  isMating
}) => {
  const actions = useAnimalTab({
    associationType,
    sex: MALE
  });
  const {
    tabLoading,
    formReloading
  } = useBullTabState(associationType, actions.loading, isMating);
  const hideTable = actions.isAnimalsPageEmpty && actions.animalsSessionState !== 'selection' || tabLoading;
  const organizations = useSelector(matingSelector.organizations);
  const {
    t: tTable
  } = useOurTranslation('tables');
  const {
    t
  } = useOurTranslation('mating');
  const table = useMemo(() => <MatingBullsTable associationType={associationType} loading={actions.loading} />, [actions.loading, associationType]);
  return <Fragment>
            {(tabLoading || formReloading) && <Loader size="large" show text={loadingMsg} spacing />}
            {!(tabLoading || formReloading) && <LoaderWrapper loading={actions.loading.includes('loadingAnimalsFromFile')} text={t('addingAnimalsFromFile')} size="large" background>
                    <MatingBullsFilterForm associationType={associationType} organizations={organizations} criteriaAccordions={actions.criteriaAccordions} criteriaDefinitions={actions.criteriaDefinitions} animalListsEmpty={actions.animalLists.forAll(isEmpty)} criteriaListsEmpty={actions.criteriaLists.forAll(isEmpty)} isAnimalsPageEmpty={actions.isAnimalsPageEmpty} organizationsLoading={actions.loading.includes('organizations')} onSubmit={actions.filterAnimals} toggleAnimalListsVisibility={actions.toggleAnimalListsVisibility} toggleAddAnimalsVisibility={actions.toggleAddAnimalsVisibility} toggleAddAnimalsFromDBVisibility={actions.toggleAddAnimalsFromDBVisibility} toggleListsOverviewVisibility={actions.toggleListsOverviewVisibility} toggleCriteriaListsVisibility={actions.toggleCriteriaListsVisibility} toggleCriteriaListDetailsVisibility={actions.toggleCriteriaListDetailsVisibility} />
                </LoaderWrapper>}

            {actions.isAnimalsPageEmpty && actions.animalsSessionState === 'filter' && <div className="p-2"><Ant.Empty description={tTable('noRows')} /></div>}
            <div className={classNames(hideTable && 'd-none')}>{table}</div>
            <MatingBullsModals isAnimalsPageEmpty={actions.isAnimalsPageEmpty} associationType={associationType} tableSettingsNameList={actions.tableNameLists} animalLists={actions.animalLists} criteriaLists={actions.criteriaLists} criteriaDefinitions={actions.criteriaDefinitions} toggleAnimalListsVisibility={actions.toggleAnimalListsVisibility} toggleAddAnimalsVisibility={actions.toggleAddAnimalsVisibility} toggleAddAnimalsFromDBVisibility={actions.toggleAddAnimalsFromDBVisibility} toggleListsOverviewVisibility={actions.toggleListsOverviewVisibility} toggleCriteriaListsVisibility={actions.toggleCriteriaListsVisibility} toggleCriteriaListDetailsVisibility={actions.toggleCriteriaListDetailsVisibility} data-sentry-element="MatingBullsModals" data-sentry-source-file="index.tsx" />
        </Fragment>;
};
export const BullSelectionTab = memo(BullSelectionTabBase);